const menuButton = document.querySelector('.menu-toggle');
const navigation = document.querySelector('#primary-nav');

if (menuButton && navigation) {
  const closeMenu = () => {
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
    navigation.classList.remove('is-open');
  };
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.classList.toggle('is-open', open);
  });
  navigation.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
}

const filterButtons = [...document.querySelectorAll('[data-filter]')];
const journalRows = [...document.querySelectorAll('.journal-row')];
const searchInput = document.querySelector('#article-search');
const resultsCount = document.querySelector('#results-count');
const emptyState = document.querySelector('#journal-empty');

if (filterButtons.length && journalRows.length && searchInput) {
  let selectedCategory = 'All';
  const updateResults = () => {
    const query = searchInput.value.trim().toLocaleLowerCase('en-GB');
    let matches = 0;
    journalRows.forEach((row) => {
      const categoryMatches = selectedCategory === 'All' || row.dataset.category === selectedCategory;
      const searchMatches = row.textContent.toLocaleLowerCase('en-GB').includes(query);
      const show = categoryMatches && searchMatches;
      row.hidden = !show;
      if (show) matches++;
    });
    if (resultsCount) resultsCount.textContent = `${matches} ${matches === 1 ? 'article' : 'articles'}`;
    if (emptyState) emptyState.hidden = matches !== 0;
  };
  filterButtons.forEach((button) => button.addEventListener('click', () => {
    selectedCategory = button.dataset.filter;
    filterButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    updateResults();
  }));
  searchInput.addEventListener('input', updateResults);
  updateResults();
}

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!reduceMotion && document.body.dataset.motion !== 'false' && 'IntersectionObserver' in window) {
  const motionSelectors = [
    '.hero-content > *', '.hero-art', '.product-picture', '.product-text > *',
    '.film-intro > *', '.film-frame', '.founder-statement > *', '.founder-copy > *',
    '.future-content > *', '.partner-image-wrap', '.partner-content > *',
    '.home-journal-heading > *', '.home-journal-grid > *', '.closing-inner > *',
    '.shop-intro > *', '.shop-hero-media', '.shop-hero-copy > *', '.shop-card',
    '.shop-outro > *', '.journal-intro > *', '.journal-featured > *',
    '.journal-list-heading > *', '.journal-row'
  ];
  const elements = [...document.querySelectorAll(motionSelectors.join(','))];
  elements.forEach((element, index) => {
    element.classList.add('reveal');
    element.style.setProperty('--reveal-delay', `${(index % 4) * 85}ms`);
  });
  document.documentElement.classList.add('motion-ready');
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }
  }, { threshold: 0.08, rootMargin: '0px 0px -25px 0px' });
  requestAnimationFrame(() => elements.forEach((element) => observer.observe(element)));
}


document.querySelectorAll('[data-variant-select]').forEach((select) => {
  const price = select.closest('.product-details')?.querySelector('[data-product-price]');
  const update = () => { if (price) price.textContent = select.selectedOptions[0]?.dataset.price || ''; };
  select.addEventListener('change', update);
});
